import service from './http'
import serve from "@/utils/serve";
import mountQuery from "@/utils/mountQuery";
import Idea from "@/types/Idea";
import Plain from "@/types/Plain";
type SystemAlias = { systemAlias: string }
type SystemIdeaAlias = { systemAlias: string, ideaAlias: string }
type Options = { options: string[] };
const defaultOptions: Config = {meta: [], options: []}
type Config = { meta?: Array<string>, options?: Array<string>, filter?: Plain }


class IdeaService {

    async add({systemAlias}: SystemAlias, idea: any) {
        return await serve(async () => await service.post(`systems/${systemAlias}/ideas`, idea))
    }

    async list({systemAlias}: SystemAlias, config?: Config) {
        return await serve(async () => await service.get(`systems/${systemAlias}/ideas${mountQuery(config)}`)) as Idea[]
    }

    async get({systemAlias, ideaAlias}: SystemIdeaAlias, config?: Config) {

        return await serve(async () => await service.get(`systems/${systemAlias}/ideas/${ideaAlias}${mountQuery(config)}`)) as {value: Idea, relDomains?: any, reverseInfo?: any}
    }

    async update({systemAlias, ideaAlias}: SystemIdeaAlias, changes: any) {
        return await serve(async () => await service.patch(`systems/${systemAlias}/ideas/${ideaAlias}`, changes))
    }

    async delete({systemAlias, ideaAlias}: SystemIdeaAlias) {
        return await serve(async () => await service.delete(`systems/${systemAlias}/ideas/${ideaAlias}`))
    }
}

export default IdeaService